const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b7c0bd19-c524-47aa-9544-d24ee046d117",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.02 10.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.49,7.76a3,3,0,0,1-.11-.49,3,3,0,0,1,0-.6,1.93,1.93,0,0,1,.18-.85A3.64,3.64,0,0,1,2,5.11a6,6,0,0,1,.61-.63,7,7,0,0,0,.6-.62,3.25,3.25,0,0,0,.47-.65,1.61,1.61,0,0,0,.19-.75,1.36,1.36,0,0,0-.51-1.08,1.71,1.71,0,0,0-.54-.27A2.32,2.32,0,0,0,2.15,1,2.83,2.83,0,0,0,0,2V.7A4.3,4.3,0,0,1,2.32,0,3.6,3.6,0,0,1,3.37.15a2.48,2.48,0,0,1,.86.43,2.12,2.12,0,0,1,.58.72,2.31,2.31,0,0,1,.21,1,2.25,2.25,0,0,1-.19,1,2.83,2.83,0,0,1-.48.78,6.56,6.56,0,0,1-.62.67c-.23.2-.44.41-.63.61A3.5,3.5,0,0,0,2.62,6a1.4,1.4,0,0,0-.19.73,2.31,2.31,0,0,0,.08.61c.06.18.11.34.16.46Zm.66,3.05a.85.85,0,0,1-.57-.23A.78.78,0,0,1,1.34,10a.76.76,0,0,1,.24-.57.8.8,0,0,1,1.14,0A.74.74,0,0,1,3,10a.76.76,0,0,1-.25.58A.81.81,0,0,1,2.15,10.81Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9aa150ebeeb44e85ea400d4191ba9d3c.svg";
export { ForwardRef as ReactComponent };